import * as Const from '../constants/index';
import State from '../interfaces/state/DownloadFileState';

const initState: State = {
  isLoading: false,
  isError: false,
};

export default function downloadFile(state: State = initState, action: any): State {
  switch (action.type) {
    case Const.DOWNLOAD_FILE_INIT:
    case Const.INIT_ALL_APP:
      return {
        ...initState,
      };

    case Const.DOWNLOAD_FILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
      };

    case Const.DOWNLOAD_FILE_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };

    case Const.DOWNLOAD_FILE_PENDING:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };

    default:
      return state;
  }
}
